import { jwtDecode } from 'jwt-decode'

import { getItem } from './local-storage'
import parseJSON from './parser'
import { Role } from './types'
import { TokenJwtPayload, TokenPayloadInterface } from './types/token'

const MILLISECONDS_IN_A_DAY = 1000 * 60 * 60 * 24
const TOKEN_EXPIRY_WARNING_DAYS = 7

const hasToken = (token: TokenPayloadInterface): boolean => {
  const {
    access_token: { token: accessToken },
    refresh_token: { token: refreshToken },
  } = token

  return accessToken !== '' && refreshToken !== ''
}

const isTokenExpired = (token: TokenPayloadInterface): boolean => {
  const {
    access_token: { expires_at },
  } = token

  const currentTime = new Date().getTime()
  const tokenExpiryTime = new Date(expires_at).getTime()
  const timeDifference = tokenExpiryTime - currentTime
  const timeDifferenceInDays = timeDifference / MILLISECONDS_IN_A_DAY
  return timeDifferenceInDays <= TOKEN_EXPIRY_WARNING_DAYS
}

const getTokenFromLocalStorage: () =>
  | TokenPayloadInterface
  | undefined
  | null = () => parseJSON(getItem('tokens', ''))

const extractRoleFromToken = (): Role | undefined => {
  const token = getTokenFromLocalStorage()?.access_token.token

  if (!token) {
    return undefined
  }

  try {
    const decoded = jwtDecode<TokenJwtPayload>(token)
    return decoded?.payload?.role
  } catch (error) {
    return undefined
  }
}

export {
  hasToken,
  isTokenExpired,
  getTokenFromLocalStorage,
  extractRoleFromToken,
}
